<template>
  <div class="alignment-buttons">
    <button
      @click="editor.chain().focus().setTextAlign('left').run()"
      :class="{
        'is-active': editor.isActive({ textAlign: 'left' }),
      }"
      title="Align Left"
    >
      <img
        width="20"
        src="/images/tiptap-bar/align-left.svg"
        alt="Align Left"
      />
    </button>
    <button
      @click="editor.chain().focus().setTextAlign('center').run()"
      :class="{
        'is-active': editor.isActive({ textAlign: 'center' }),
      }"
      title="Align Center"
    >
      <img
        width="20"
        src="/images/tiptap-bar/align-center.svg"
        alt="Align Center"
      />
    </button>
    <button
      @click="editor.chain().focus().setTextAlign('right').run()"
      :class="{
        'is-active': editor.isActive({ textAlign: 'right' }),
      }"
      title="Align Right"
    >
      <img
        width="20"
        src="/images/tiptap-bar/align-right.svg"
        alt="Align Right"
      />
    </button>
    <button
      @click="editor.chain().focus().setTextAlign('justify').run()"
      :class="{
        'is-active': editor.isActive({ textAlign: 'justify' }),
      }"
      title="Justify"
    >
      <img
        width="20"
        src="/images/tiptap-bar/align-justify.svg"
        alt="Justify"
      />
    </button>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  editor: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.alignment-buttons {
  display: flex;
  gap: 10px;
}
</style>
